import { THEMES, THEME_IDS } from '../theme/themes';
import { useTheme } from '../theme/ThemeProvider';
import type { ThemeColors } from '../theme/theme.types';

const SWATCH_ORDER: (keyof ThemeColors)[] = [
  'background',
  'surface',
  'primary',
  'secondary',
  'text',
  'heading',
  'decoration',
];

export default function ThemeSwitcher() {
  const { themeId, setTheme } = useTheme();

  return (
    <section className="colibri-theme-switcher" aria-label="Оформление приложения">
      <p className="colibri-theme-switcher__title">Оформление приложения</p>
      <p className="colibri-theme-switcher__sub">
        Выберите цветовую тему Colibri. Она применяется ко всем разделам приложения
      </p>
      <div className="colibri-theme-switcher__grid" role="group" aria-label="Цветовые темы">
        {THEME_IDS.map((id) => {
          const theme = THEMES[id];
          const active = themeId === id;
          return (
            <button
              key={id}
              type="button"
              className={`colibri-theme-card${active ? ' colibri-theme-card--active' : ''}`}
              aria-pressed={active}
              onClick={() => setTheme(id)}
            >
              <span className="colibri-theme-card__name">{theme.name}</span>
              <span className="colibri-theme-card__swatches">
                {SWATCH_ORDER.map((key) => (
                  <span
                    key={key}
                    className="colibri-theme-card__swatch"
                    style={{ background: theme.colors[key] }}
                  />
                ))}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
